import ReactDOM from 'react-dom';
import { BrowserRouter, Redirect, Switch } from 'react-router-dom';

import AdminLayout from 'layouts/Admin';

import PrivateRoute from 'components/PrivateRoute/PrivateRoute';
import { ConfigurationQueryProvider } from 'services/configurationQueryProvider';
import AppAuthProvider from './providers/appAuthProvider';

ReactDOM.render(
	<BrowserRouter>
		<Switch>
			<AppAuthProvider>
				<ConfigurationQueryProvider >
					<PrivateRoute path="/sistema" component={AdminLayout} />
				</ConfigurationQueryProvider>
			</AppAuthProvider>
			<Redirect from="/" to="/sistema/dashboard" />
		</Switch>
	</BrowserRouter>,
	document.getElementById('root')
);
